import { LanguageEnum } from '../../utils';

export const copyWritings = {
  production: {
    [LanguageEnum.chinese]: '全部产品',
    [LanguageEnum.english]: 'Productions',
  },
  blog: {
    [LanguageEnum.chinese]: '博客',
    [LanguageEnum.english]: 'Blog',
  },
  soon: {
    [LanguageEnum.chinese]: '（敬请期待）',
    [LanguageEnum.english]: ' (Coming Soon)',
  },
};
